<script>
export default {
    data() {
        return {
            borderColor: '#000000',
        };
    },
    computed: {
        role() {
            return this.$store.getters.ROLES_BY_ID(this.roleID);
        },
    },
    props: {
        roleID: Number,
    },
    mounted() {
        if (this.role.can_edit_asset_types) {
            this.borderColor = '#fc424ab2';
            return;
        } else if (this.role.can_edit_games || this.role.can_edit_providers) {
            this.borderColor = '#fc9742b2';
            return;
        } else if (this.role.can_use_admin) {
            this.borderColor = '#42a7fcb2';
            return;
        }

        this.borderColor = '#d6d6d6b2';
    },
};
</script>

<template>
    <div class="fake_button" :style="{ backgroundColor: `${borderColor}` }">
        <label>{{ role['name'] }}</label>
    </div>
</template>
